import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import ShiftContainer from '../../containers/Shift';
import { TimePicker }  from "@material-ui/pickers";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import FormCheckBox from '../form/FormCheckbox';

const styles = () => {
	return {
		row: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			marginTop: 5,
			marginBottom: 8,
			justifyContent: 'flex-start',
		},
		shiftDisplay: {
			fontSize: 16,
			color: '#444',
			marginRight: 20,
			minWidth: 60,
			textAlign: 'right',
		},
		timePicker: {
			maxWidth: 200,
		},
	};
};

class EquipmentAssignmentShiftSchedules extends PureComponent {
	onChangeTime(shiftId, momentValue) {
		const { value, onChange, path } = this.props;

		const newValue = value.map((val) => {
			if (shiftId === val.shiftId) {
				return {
					...val,
					shiftTime: momentValue.format('HH:mm:ss'),
				};
			} else {
				return {
					...val,
				};
			}
		});

		onChange(newValue, path);
	}

	componentDidMount() {
		const { shifts, searchShifts } = this.props;
		// make sure we have the shifts for display purposes
		if (_.isEmpty(shifts)) {
			searchShifts();
		}
	}

	onCheckChange = (shiftId, checked) => {
		const { value, path, onChange } = this.props;

		if (checked) {
			let shiftTime = '01:00:00';
			if (shiftId === 2) {
				shiftTime = '13:00:00';
			}
			if (value.length && value.length === 1) {
				const otherTime = value[0].shiftTime;
				shiftTime = moment(`2019-06-01 ${otherTime}`).add(12, 'hours').format("HH:mm:ss");
			}

			const newValue = [
				...value,
				{
					shiftId,
					shiftTime,
				}
			];

			onChange(newValue, path);
		} else {
			const newValue = value.filter((val) => {
				return val.shiftId !== shiftId;
			});
			onChange(newValue, path);
		}
	};

	render () {
		const { classes, gridProps, label, shifts, value } = this.props;

		const valueMap = _.keyBy(value, 'shiftId');

		return (
			<Grid item {...gridProps} style={{marginTop : 20}}>
				<InputLabel>{label}</InputLabel>
				<div>
					{shifts.map(({ shiftId, display }) => {
						const val = valueMap[shiftId];
						return (
							<div key={shiftId} className={classes.row}>
								<div className={classes.shiftDisplay}>{display}</div>
								<FormCheckBox
									label={''}
									path={''}
									checked={!!val}
									onChange={this.onCheckChange.bind(this, shiftId)}
									fullWidth={false}
								/>
								{!!val && (
									<TimePicker
										variant='inline'
										ampm={true}
										value={moment(`2019-01-01 ${val.shiftTime}`)}
										minutesStep={5}
										onChange={this.onChangeTime.bind(this, shiftId)}
										classes={{
											root: classes.timePicker
										}}
									/>
								)}
							</div>
						);
					})}
				</div>
			</Grid>
		);
	}
}

EquipmentAssignmentShiftSchedules.propTypes = {
	value: PropTypes.array,
	label : PropTypes.string,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	//error : PropTypes.string,
	//classes : PropTypes.object,
	//helpText : PropTypes.string,
};

EquipmentAssignmentShiftSchedules.defaultProps =  {
	label : 'Shift Schedule Times',
	value: [],
	shifts: [],
};

export default _.flow([
	withStyles(styles),
	ShiftContainer,
])(EquipmentAssignmentShiftSchedules);

